<template>
  <div>
    <Head title="Çmimet" />


    <h1 class="mb-6 text-3xl font-bold">Çmimet</h1>

    <div v-for="business in businesses">
      <div class="flex items-center mb-6">
        <h2 class="mt-12 text-2xl font-bold">{{ business.name }}</h2>
      </div>
    <div  class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Shteti</th>
          <th class="pb-4 pt-6 px-6">Madhësia</th>
          <th class="pb-4 pt-6 px-6">Çmimi i transportit</th>
          <th class="pb-4 pt-6 px-6" >Çmimi i anulimit</th>
          <th class="pb-4 pt-6 px-6" >Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="pricing in pricings.data.filter(obj => obj.business_id === business.id)" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
              {{ pricing.country_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4"  tabindex="-1">
              {{ pricing.package_size_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4"  tabindex="-1">
              {{ pricing.shipping_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4"  tabindex="-1">
              {{ pricing.cancellation_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4"  tabindex="-1">
              {{ pricing.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4"  tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="pricings.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë çmim.</td>
        </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'

export default {
  components: {
    DangerFlashMessage,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    pricings: Object,
    businesses: Array
  },
}
</script>
